import React, { useRef, useEffect, useState } from "react";
import useStore from "../store";
import Lottie from "../util/Lottie.react";
import { useSpring, animated as a } from "react-spring";
import gameStates from "../util/gameStates";
import * as fullscreenAnimation from "../lottie/maximize-minimize.json";
import * as volumeAnimation from "../lottie/volume.json";
import * as pulseAnimation from "../lottie/pulse.json";
import * as micAnimation from "../lottie/microphone.json";
import { firestore } from "firebase";

const Intro = () => {
  const { setGameState } = useStore((state) => state.actions);
  return (
    <div className="intro">
      <button onClick={() => setGameState(gameStates.PLAYING)}>Start</button>
    </div>
  );
};

function UILayer() {
  const gameState = useStore((state) => state.gameState);
  const { setPrompts } = useStore((state) => state.actions);

  useEffect(() => {
    firestore()
      .collection("questions")
      .get()
      .then((snap) => {
        const docs = snap.docs;
        setPrompts(Object.fromEntries(docs.map((doc) => [doc.id, doc.data()])));
      });
  }, []);

  return (
    <div className="uilayer">
      {gameState === gameStates.INTRO && <Intro />}

      <div
        className={
          "hud " +
          (gameState === gameStates.LOADING || gameState === gameStates.INTRO
            ? " hidden"
            : "")
        }
      >
        <Header />
        {gameState !== gameStates.INTO && gameState !== gameStates.LOADING ? (
          <Prompt />
        ) : null}
        <Footer />
      </div>
    </div>
  );
}

function Header() {
  return (
    <div className="header">
      <div className="logo">alonetogether</div>
    </div>
  );
}

function Prompt() {
  const gameState = useStore((state) => state.gameState);
  const currentPromptID = useStore((state) => state.currentPromptID);
  const prompts = useStore((state) => state.prompts);
  const currentAnswers = useStore((state) => state.currentAnswers);
  const { setGameState, setCurrentAnswers, setCurrentPromptID } = useStore(
    (state) => state.actions
  );

  const [currentAnswer, setCurrentAnswer] = useState(null);

  // use to emulate prompt
  useEffect(() => {
    window.addEventListener(
      "keydown",
      (e) => {
        if (e.key === "p") {
          setCurrentPromptID("eHLeYJ5merkAfk6fRNhK");

          if (gameState === gameStates.PROMPT) {
            setGameState(gameStates.PLAYING);
          } else {
            setGameState(gameStates.PROMPT);
          }
        }
        if (e.key === "o") {
          setCurrentPromptID("ImJtp5QAecA9v2LrvgFl");
          if (gameState === gameStates.PROMPT) {
            setGameState(gameStates.PLAYING);
          } else {
            setGameState(gameStates.PROMPT);
          }
        }
      },
      { once: true }
    );
  }, [gameState, setCurrentPromptID, setGameState]);

  // getting the answers to the current prompt
  // Wondering if we should get these when needed or just get all in the beginning like the questions?
  useEffect(() => {
    if (prompts == null || prompts[currentPromptID] == null) {
      return;
    }
    Promise.all(
      prompts[currentPromptID].answers.map((answer) =>
        firestore().collection("answers").doc(answer).get()
      )
    ).then((resolvedAnswers) => {
      const answers = resolvedAnswers.map((answer) => answer.data());
      setCurrentAnswers(answers);
    });
  }, [prompts, currentPromptID, setCurrentAnswers]);

  const { opacity } = useSpring({
    opacity: gameState === gameStates.PROMPT ? 1 : 0,
    config: { mass: 5, tension: 500, friction: 80 },
  });

  if (prompts == null || prompts[currentPromptID] == null) {
    return null;
  }

  console.log("ans ", currentAnswers);

  return (
    <div className="content">
      <a.div className="promptContainer" style={{ opacity }}>
        {gameState === gameStates.PROMPT && (
          <div className="promptContainerPointers">
            <h1>{prompts[currentPromptID].prompt}</h1>
            <div className="answers">
              {currentAnswers.map((answer) => {
                const { author, location, url } = answer;
                return (
                  <div
                    className={`answer ${
                      currentAnswer === answer ? "active" : ""
                    }`}
                    onClick={() => {
                      setCurrentAnswer(answer);
                      const audioPlayer = document.getElementById(
                        "audioPlayer"
                      );
                      audioPlayer.src = url;
                      audioPlayer.play();
                    }}
                  >
                    {/* <Lottie
                      animationData={pulseAnimation.default}
                      lottieClass="dots"
                      loop={true}
                    /> */}
                    <div className="dot"></div>
                    <div className="info">
                      <p>{`${author || "Anonymous"}, ${
                        location || "Unkown"
                      }`}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </a.div>
    </div>
  );
}

function Footer() {
  return (
    <div className="footer">
      <div></div>
      <div className="controlsContainer">
        <Lottie
          animationData={volumeAnimation.default}
          lottieClass="controls"
        />
        <Lottie animationData={micAnimation.default} lottieClass="controls" />
        <Lottie
          animationData={fullscreenAnimation.default}
          lottieClass="controls"
          onLottieClickIn={() => {
            document.documentElement.requestFullscreen();
          }}
          onLottieClickOut={() => {
            document.exitFullscreen();
          }}
        />
      </div>
    </div>
  );
}

export default UILayer;
